<template>
  <div class="leave-form-wrap">
    <van-nav-bar
      right-text="历史记录"
      @click-right="$router.push('/studentLeaveList')"
    >
    </van-nav-bar>
    <van-form validate-first :show-error="false" @submit="onSubmit">
      <div class="form-wrap">
        <!-- <van-field
          label="请假人"
          size="large"
          :rules="rules.leaveName"
          v-if="personType == 13"
          v-model="form.leaveName"
          readonly
        >
        </van-field> -->
        <van-field label="请假人" size="large" :rules="rules.leaveName">
          <template #input>
            <van-radio-group v-model="form.radio" direction="horizontal">
              <van-radio
                @click="handleClickRadio()"
                :name="item"
                style="margin-bottom: 5px;"
                v-for="(item, index) in childList"
                :key="index"
                >{{ item.name }}({{ item.className }})</van-radio
              >
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          v-model="form.leaveType"
          label="请假事项"
          placeholder="点击选择"
          clickable
          readonly
          is-link
          size="large"
          @click="showPicker = true"
          :rules="rules.leaveType"
        />
        <van-field
          type="textarea"
          placeholder="请输入原因"
          label="请假原因"
          autosize
          v-model="form.remark"
          size="large"
        />

        <van-field
          v-model="form.leaveBeginTime"
          label="开始时间"
          placeholder="点击选择"
          clickable
          readonly
          is-link
          @click="clickTime('starttime')"
          :rules="rules.leaveBeginTime"
          size="large"
        />
        <van-field
          v-model="form.leaveEndTime"
          label="结束时间"
          placeholder="点击选择"
          clickable
          readonly
          is-link
          :rules="rules.leaveEndTime"
          @click="form.leaveBeginTime && clickTime('endtime')"
          size="large"
        />
        <!-- <van-field
          v-model="form.auditName"
          label="审批人"
          placeholder="请选择审批人"
          size="large"
          clickable
          readonly
          :rules="rules.auditName"
          @click="$refs.interviewee.showiIntervieweePopup = true"
        /> -->


        <van-collapse class="collapse" v-model="activeNames">
          <van-collapse-item name="1" >
            <template #title>
              <div style="color: #646566; fontSize: 1rem">审批人</div>
            </template>
            
            <!-- 审批人选择弹窗 -->
            <div class="audit_select">
              <!-- 添加成功的审批人列表 -->
              <div
                v-for="(item, index) in auditList"
                :key="item.id"
                class="audit_list"
                @click.stop="handleClickAudit(index)"
              >
                <div
                  class="audit_close"
                  @click.stop="auditList.splice(index, 1)"
                >
                  <van-icon name="cross" />
                </div>
                <img :src="item.avatar" alt="" />
                <span>{{ item.auditName }}</span>
              </div>

              <!-- 添加审批人按钮 -->
              <div
                class="audit_add"
                @click="
                  () => {
                    auditIndex = undefined;
                    $refs.interviewee.showiIntervieweePopup = true;
                  }
                "
              >
                <van-icon name="plus" />
              </div>
            </div>
          </van-collapse-item>
        </van-collapse>

        <van-field
          v-model="form.makeInfo"
          label="抄送范围"
          placeholder="点击选择"
          clickable
          readonly
          is-link
          size="large"
          @click="$refs.ccrequest.showCcRequest = true"
        />


        <van-field
          v-model="duration"
          label="时长"
          placeholder="时长"
          size="large"
          readonly
          v-if="form.leaveBeginTime && form.leaveEndTime && form.leaveType"
        />
      </div>

      <div style="margin: 16px;">
        <van-button
          round
          block
          :loading="btn_loading"
          :disabled="btn_loading"
          type="info"
          native-type="submit"
        >
          提交
        </van-button>
      </div>
    </van-form>
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker
        title="事项"
        show-toolbar
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>
    <SelectTime
      ref="starttime"
      :typeTime="'选择开始时间'"
      @time="handleTimeStartConfirm"
      :currentDate="startMinTime"
      :minDate="new Date()"
      :isFilter="false"
    />
    <SelectTime
      ref="endtime"
      :typeTime="'选择结束时间'"
      @time="handleTimeEndConfirm"
      :minDate="endMinDate"
      :isFilter="false"
      :currentDate="endCurTime"
    />
    <Interviewee
      ref="interviewee"
      @selectItem="handleSelIntervieweeItem"
      pageType="student"
    />
    <!-- 抄送人组件  -->
    <CcRequest personType="person" leaveType="0" ref="ccrequest" @selectItem="handleCcSelectItem"/>
  </div>
</template>

<script>
import moment from 'moment'
import { compare, getDateYMD, timeFormart } from '@/utils'
import CcRequest from '@/components/subScribePopup/ccrequest'
import Interviewee from '@/components/subScribePopup/interviewee'
import SelectTime from '@/components/subScribePopup/selectTime'
export default {
  data() {
    return {
      form: {},
      showPicker: false,
      columns: [
        '事假',
        '病假',
        '工伤假',
        '婚假',
        '丧假',
        '产假',
        '探亲假',
        '公假',
        '年休假',
      ],
      endMinDate: '',
      btn_loading: false,
      childList: [],
      startMinTime: new Date(
        moment()
          .endOf('hours')
          .add(1, 's')
      ),
      // moment()
      //   .endOf('hours')
      //   .add(1, 's')
      activeNames: ["1"],
      // 审批人列表
      auditList: [],
      auditIndex: undefined, // 当前选择更改的审批人的序号
      duration: '',
      durationMs: '',
      makeUserList:[],
      // 抄送部门列表
      makeDeptList: [],
      rules: {
        leaveType: [
          {
            required: true,
            message: '请选择事项',
            trigger: 'onChange',
          },
        ],
        leaveBeginTime: [
          {
            required: true,
            message: '请选择时间',
            trigger: 'onChange',
          },
        ],
        leaveEndTime: [
          {
            required: true,
            message: '请选择时间',
            trigger: 'onChange',
          },
        ],
        // auditName: [
        //   {
        //     required: true,
        //     message: '请选择审批人',
        //     trigger: 'onChange',
        //   },
        // ],
        remark: [
          {
            required: true,
            message: '请填写备注',
            validator: (value, rule) => {
              rule.message = '输入字符大于50位'
              return value.length <= 50
            },
          },
        ],
        leaveName: [
          {
            required: true,
            message: '请选择请假人',
            trigger: 'onChange',
          },
        ],
      },
    }
  },

  mounted() {
    // if (this.personType == 12) {
    //   this.getAllChild()
    // }
    this.getAllChild()
    // if (this.personType == 13) {
    //   const uname = JSON.parse(localStorage.getItem('userInfo')).name
    //   this.$set(this.form, 'leaveName', uname)
    // }
    this.getLastLeaveDetail()
  },
  computed: {
    personType() {
      return JSON.parse(localStorage.getItem('userInfo')).personType
    },

    endCurTime() {
      return new Date(moment(this.endMinDate).add(1, 'h'))
    },
    endMaxTime() {
      return new Date(moment(this.endMinDate).add(this.maxDuration, 'hours'))
    }
    // duration() {
    //   var m1 = moment(this.form.leaveBeginTime),
    //     m2 = moment(this.form.leaveEndTime)
    //   var du = moment.duration(m2 - m1, 'ms'),
    //     month = du.get('month'),
    //     day = du.get('days'),
    //     hours = du.get('hours'),
    //     mins = du.get('minutes'),
    //     ss = du.get('seconds')
    //   const duration =
    //     month + '月' + day + '天' + hours + '时' + mins + '分' + ss + '秒'
    //   return duration
    //   // this.$set(this.form, 'visitorIdCrde', duration)
    // },
  },
  methods: {
    onConfirm(value, index) {
      this.$set(this.form, 'leaveType', value)
      this.showPicker = false
      if (this.form.leaveBeginTime && this.form.leaveEndTime && this.form.leaveType) {
        this.timeDuration()
      }
    },
    clickTime(type) {
      this.$refs[type].showTimePopup = true
    },

    // 切换请假人时触发
    handleClickRadio () {
      console.log('触发',this.form)
      if (this.form.leaveBeginTime && this.form.leaveEndTime && this.form.leaveType) {
        this.timeDuration()
      }
    },
     // 设置请假时长并进行时间转换
     async timeDuration () {
        // 获取请假时长
        let res = await this.$https.getCalculationTime({
          leaveBeginTime: timeFormart(this.form.leaveBeginTime),
          leaveEndTime: timeFormart(this.form.leaveEndTime),
          leaveId: this.form.radio.id,
          schoolId: this.$store.state.pschoolId,
          leaveType: this.form.leaveType,
          userId: this.$store.state.puserId
          
        });
        if (res.code == 200) {
          this.durationMs = res.data
          this.duration = this.renderTime(res.data)
        } else {
          this.$toast(res.msg);
        }
    },

    renderTime(data) {
      let leaveTime = data.leaveTime
      let workTime = data.workTime

      let StatusMinute = ''
      var day = parseInt(leaveTime/workTime);
      var hour = parseInt((leaveTime % workTime) / 60); // 小时
      var min = parseInt((leaveTime % workTime) % 60); // 分钟
      if (day > 0) {
        StatusMinute = day + "天";
      }
      if (hour > 0) {
        StatusMinute += hour + "小时";
      }
      if (min > 0) {
        StatusMinute += parseFloat(min) + "分钟";
      }
      return `${StatusMinute || '0分钟'}`;

    },

    handleTimeStartConfirm(value) {
      this.$set(this.form, 'leaveBeginTime', value)
      this.endMinDate = new Date(value.replace(/-/g, '/'))
      if (this.form.leaveBeginTime && this.form.leaveEndTime && this.form.leaveType) {
        this.timeDuration()
      }
      this.$refs.starttime.showTimePopup = false
      this.$refs.endtime.showTimePopup = true
    },
    handleTimeEndConfirm(value) {
      this.$set(this.form, 'leaveEndTime', value)
      if (this.form.leaveBeginTime && this.form.leaveEndTime && this.form.leaveType) {
        this.timeDuration()
      }
      this.$refs.endtime.showTimePopup = false
    },



    handleSelIntervieweeItem(item) {
      // 判断当前是否选过当前审批人
      if (this.auditList.some((x) => x.auditId == item.id)) {
        this.$toast('已有当前审批人')
        return
      }
      // 判断审批人是添加还是替换
      if (this.auditIndex === undefined) {
        this.auditList.push({
          auditId: item.id,
          avatar: item.avatar,
          auditName: item.name,
          auditDeptName: item.deptName,
        });
        this.$refs.interviewee.showiIntervieweePopup = false;
      } else {

        this.auditList.splice(this.auditIndex,1,{
          auditId: item.id,
          avatar: item.avatar,
          auditName: item.name,
          auditDeptName: item.deptName,
        })
        this.$refs.interviewee.showiIntervieweePopup = false;
        
      }

    },
    // 抄送人返回数据
    handleCcSelectItem (item) {
      let {makeDeptList,makeUserList,state} = item
      let str = ''
      if (makeDeptList.length > 0) {
        if (makeDeptList.length == 1) {
          str = str + makeDeptList[0].deptName
        } else {
          str = str + makeDeptList.length + '个部门'
        }
      } 

      if (makeUserList.length > 0) {
        if (makeUserList.length == 1) {
          str = str + makeUserList[0].name
        } else {
          str = str + makeUserList.length + '位老师'
        }
      } 
      this.$set(this.form, "makeInfo", str);
      this.makeUserList = makeUserList.map(x => {
        return {
          id: x.id,
          name: x.name,
          remark: x.deptName,
          avatar: x.avatar
        }
      })
      if (state == 1) {
        this.$refs.ccrequest.showCcRequest = false;
      }
      
    },

    // 点击审批人头像更换审批人 
    handleClickAudit (index) {
        console.log('获取当前序号',index)
        this.auditIndex = index
        this.$refs.interviewee.showiIntervieweePopup = true
    },

    // 提交
    onSubmit(v) {
      // 判断有审批人
      if (!this.auditList.length) {
        this.$toast('请添加审批人')
        return 
      }
      if (this.durationMs == 0 ||this.durationMs == '' ) {
        this.$toast("请假时长应大于0");
        return;
      }
      let auditUsers = this.auditList.map((item,index) => {
        return {
          indexCode: index + 1,
          auditId: item.auditId,
          auditName : `${item.auditName} - ${item.auditDeptName}`,
          auditDeptName: item.auditDeptName
        }
      })
      // this.btn_loading = true
      const { leaveBeginTime, leaveEndTime, radio, ...rest } = this.form
      let leaveName = {
        leaveName: JSON.parse(localStorage.getItem('userInfo')).name,
      }
      if (radio && Object.keys(radio).length > 0) {
        leaveName.leaveName = radio.name
        leaveName.leaveId = radio.id
      }
      // return 
      this.$https
        .initiateMyLeave({
          ...rest,
          ...leaveName,
          auditUsers,
          // leaveName: '王云',
          // leaveId: '123444',
          leaveBeginTime: timeFormart(leaveBeginTime),
          leaveEndTime: timeFormart(leaveEndTime),
          userId: this.$store.state.puserId,
          makeUserList:this.makeUserList,
          makeDeptList: this.makeDeptList,
          schoolId: this.$store.state.pschoolId,
        })
        .then((res) => {
          if (res.code !== 200) {
            this.$toast(res.msg)
            this.btn_loading = false
            return
          }

          this.$toast({
            type: 'success',
            overlay: true,
            message: '成功',
            duration: 1500,
            onClose: () => {
              this.$router.push('/studentLeaveList')
            },
          })
        })
        .catch(() => {
          this.btn_loading = false
        })
    },

    async getAllChild() {
      const { code, data } = await this.$https.getAllChild({
        userId: this.$store.state.puserId,
        schoolId: this.$store.state.pschoolId,
      })
      if (code !== 200) {
        return
      }
      this.childList = [...data]
      this.$set(this.form, 'radio', data[0])
    },

    async getLastLeaveDetail() {
      const { code, data } = await this.$https.getLastLeaveDetail({
        userId: this.$store.state.puserId,
        schoolId: this.$store.state.pschoolId,
        leaveType: 0
      })
      if (code !== 200) {
        return
      }

      if (data && data.length) {
        data.forEach(item => {
          if (item.name && item.deptName) {
            this.auditList.push({
              avatar: item.avatar,
              auditId: item.id,
              auditName: item.name,
              auditDeptName: item.deptName,
            });
          }
        })
      }
     
      // this.$set(this.form, 'auditeDeptName', data.deptName)
      // this.$set(this.form, 'auditId', data.id)
      this.$set(
        this.form,
        'leaveBeginTime',
        moment()
          .endOf('hours')
          .add(1, 's')
          .format('YYYY-MM-DD HH:mm')
      )
      this.startMinTime = new Date(this.form.leaveBeginTime.replace(/-/g, '/'))
      this.endMinDate = new Date(this.form.leaveBeginTime.replace(/-/g, '/'))
    },
  },
  components: {
    Interviewee,
    SelectTime,
    CcRequest
  },
}
</script>

<style lang="scss" scoped>
.form-wrap {
  margin: 1rem;
  box-shadow: 0 0.25rem 1rem rgba(69, 91, 99, 0.1);
  border-radius: 0.75rem;
  overflow: hidden;
  .collapse {
    color: #fff;
    .van-collapse-item {
      .van-cell {
        .van-cell__title {
          color: red !important;
        }
      }
    }
  }
  // 审批人选择部分
  .audit_select {
    display: flex;
    flex-wrap: wrap;
    overflow: hidden;
    // background-color: pink;
    .audit_list {
      display: flex;
      flex-direction: column;
      margin-right: 1.8rem;
      margin-bottom: 1rem;
      position: relative;
      text-align: center;
      // border-radius: 50%;
      .audit_close {
        position: absolute;
        top: 0;
        right: 0;
        width: 1rem;
        height: 1rem;
        text-align: center;
        line-height: 1rem;
        font-size: 0.6rem;
        background-color: #bac6d0;
        color: #fff;
        border-radius: 50%;
      }
      &::before {
        content: ". . .";
        position: absolute;
        color: #666;
        height: 0.5rem;
        line-height: 0.1rem;
        top: 34%;
        transform: translateY(-50%);
        right: -1.5rem;
      }
      img {
        width: 3.5rem;
        height: 3.5rem;
        border-radius: 50%;
        margin-bottom: 0.3rem;
        background-color: rgba(69, 91, 99, 0.9);
      }
    }
    .audit_list:nth-child(4n) {
      margin-right: 0;
    }
    .audit_add {
      width: 3.5rem;
      height: 3.5rem;
      border-radius: 50%;
      line-height: 3.5rem;
      color: #c7c7c7 /* 33/9.59 */;
      text-align: center;
      font-size: 1.8rem;
      border: 1px solid #b8b8b8;
    }
  }
}
</style>
